export const authPages = {
  login: {
    title: 'Log in',
    emailTitle: "What's your email",
    fields: [{ name: 'email', label: 'Email address', type: 'email', autoComplete: 'username', required: true }],
    submitLabel: 'Continue',
    pendingLabel: 'Sending...',
    codeTitle: 'Log in code',
    codeFields: [
      {
        name: 'code',
        label: 'Code',
        type: 'text',
        autoComplete: 'one-time-code',
        inputMode: 'numeric',
        pattern: '[0-9]*',
        required: true,
      },
    ],
    codeSubmitLabel: 'Continue',
    codePendingLabel: 'Continuing...',
    codeBackLabel: 'Use a different email',
    backLabel: 'Back to log in',
  },
  signupInvitation: {
    title: 'Have an invite?',
    options: {
      url: 'Yes, my friend sent me a link!',
      code: 'Yes, I have a code!',
      waitlist: 'Not yet but I’ll join the waitlist',
    },
    methods: {
      url: {
        title: 'Paste URL of your invite',
        description: 'Copy and paste the link of the URL your friend sent',
        field: {
          name: 'signup_invitation',
          ariaLabel: 'Invite URL',
          placeholder: 'Paste the invite link URL',
          type: 'text',
          autoComplete: 'off',
          inputMode: 'url',
          required: true,
        },
      },
      code: {
        title: 'Enter your invite code',
        description: 'Enter the 6 character invite code',
        field: {
          name: 'signup_invitation',
          ariaLabel: 'Invite code',
          placeholder: '6 character code',
          type: 'text',
          autoComplete: 'off',
          inputMode: 'text',
          maxLength: 6,
          required: true,
        },
      },
    },
    submitLabel: 'Continue',
    pendingLabel: 'Continuing...',
    methodBackLabel: 'Back',
    backLabel: 'Back to log in',
  },
};
